<template>
  <div id="user-page">
    <div class="page-header">
      <div class="header-back" @click="goBack">
        <a-icon type="left" />
      </div>
      <div class="header-title">工作统计</div>
      <div class="header-action" v-if="isManager" @click="staffShow = true">
        <a-icon type="swap" />
      </div>
      <div class="header-action" v-else></div>
    </div>

    <div class="profile-card">
      <div class="avatar">{{ currentStaff.name ? currentStaff.name.charAt(0) : '' }}</div>
      <div class="profile-info">
        <div class="profile-name">{{ currentStaff.name }}</div>
        <div class="profile-tel">
          <a-icon type="phone" style="margin-right: 4px; font-size: 12px;" />
          {{ currentStaff.mobile }}
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-label">统计周期</div>
      <div class="period-tabs">
        <div
          v-for="(item, index) in periods"
          :key="item.value"
          class="period-tab"
          :class="{ active: currentPeriodIndex === index && !customTime }"
          @click="changePeriod(index)"
        >{{ item.label }}</div>
      </div>
      <a-config-provider :locale="locale">
        <div class="date-range">
          <div class="date-field">
            <div class="date-label">开始日期</div>
            <a-date-picker
              v-model="startTime"
              placeholder="请选择"
              @change="onChange"
              class="full-width-picker"
            />
          </div>
          <div class="date-separator">
            <a-icon type="swap-right" />
          </div>
          <div class="date-field">
            <div class="date-label">结束日期</div>
            <a-date-picker
              v-model="endTime"
              placeholder="请选择"
              @change="onChange"
              class="full-width-picker"
            />
          </div>
          <div
            class="date-confirm-btn"
            :class="{ active: customTime }"
            @click="setCustomTime"
          >
            {{ customTime ? '已选定' : '确定' }}
          </div>
        </div>
      </a-config-provider>
    </div>

    <a-spin :spinning="dataLoading">
      <div class="stats-grid">
        <div class="stat-card stat-customers" @click="goCustomerList">
          <div class="stat-icon-wrap customers-bg">
            <a-icon type="team" />
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ customerNum }}</div>
            <div class="stat-label">客户数量</div>
          </div>
          <a-icon type="right" class="stat-arrow" />
        </div>
        <div class="stat-card stat-records" @click="goRecords(0)">
          <div class="stat-icon-wrap records-bg">
            <a-icon type="message" />
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ recordNum }}</div>
            <div class="stat-label">沟通记录</div>
          </div>
          <a-icon type="right" class="stat-arrow" />
        </div>
        <div class="stat-card stat-orders" @click="goRecords(1)">
          <div class="stat-icon-wrap orders-bg">
            <a-icon type="file-text" />
          </div>
          <div class="stat-body">
            <div class="stat-value">{{ orderNum }}</div>
            <div class="stat-label">订单数量</div>
          </div>
          <a-icon type="right" class="stat-arrow" />
        </div>
        <div class="stat-card stat-amount" @click="goRecords(1)">
          <div class="stat-icon-wrap amount-bg">
            <a-icon type="pay-circle" />
          </div>
          <div class="stat-body">
            <div class="stat-value">&yen;{{ parseInt(orderAmount) }}</div>
            <div class="stat-label">订单金额</div>
          </div>
          <a-icon type="right" class="stat-arrow" />
        </div>
      </div>
    </a-spin>

    <a-modal title="选择员工" v-model="staffShow" :footer="null" class="staff-modal">
      <div class="staff-grid">
        <div
          v-for="item in sellers"
          :key="item.id"
          class="staff-item"
          :class="{ active: currentStaff.id === item.id }"
          @click="changeStaff(item)"
        >
          <div class="staff-avatar">{{ item.name ? item.name.charAt(0) : '' }}</div>
          <div class="staff-name">{{ item.name }}</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Customer from '../api/customer'
import Staff from '../api/staff'

import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')
const periods = [
  { value: 'today', label: '今天' },
  { value: 'this_week', label: '本周' },
  { value: 'this_month', label: '本月' },
  { value: 'all', label: '全部' }
]
export default {
  name: 'User',
  data () {
    return {
      moment,
      staffShow: false,
      sellers: [],
      currentStaff: {},
      dataLoading: true,
      customerNum: 0,
      recordNum: 0,
      orderNum: 0,
      orderAmount: 0,
      periods: [],
      currentPeriodIndex: 0,
      isManager: false,
      locale: zhCN,
      startTime: undefined,
      endTime: undefined,
      customTime: false
    }
  },
  created () {
    this.getStaff()
    this.getMystaffs()
    this.periods = periods
    this.getStatisticsData()
  },
  methods: {
    dateFormat (time) {
      return moment(time).format('YYYY/MM/DD')
    },
    onChange () {
      this.customTime = false
    },
    setCustomTime () {
      if (this.startTime || this.endTime) {
        this.customTime = true
        this.currentPeriodIndex = undefined

        this.getStatisticsData()
      } else {
        this.$message.error('请选择查询的时间')
      }
    },
    goCustomerList () {
      this.setFilterParams()
      this.$router.push({ name: 'home' })
    },
    goRecords (tradeIf) {
      if (this.customTime) {
        let _start = this.startTime ? this.startTime.format('YYYY-MM-DD') : ''
        let _end = this.endTime ? this.endTime.format('YYYY-MM-DD') : ''
        this.$store.dispatch('storeRecordsParams', {
          staff_id: this.currentStaff.id,
          start: _start,
          end: _end,
          trade_if: tradeIf
        })
      } else {
        this.$store.dispatch('storeRecordsParams', {
          staff_id: this.currentStaff.id,
          period: this.periods[this.currentPeriodIndex].value,
          trade_if: tradeIf
        })
      }
      this.$router.push({ name: 'records' })
    },
    changeStaff (staff) {
      this.currentStaff = staff
      this.dataLoading = true
      this.staffShow = false
      this.getStatisticsData()
    },
    changePeriod (index) {
      this.dataLoading = true
      this.currentPeriodIndex = index

      this.endTime = this.startTime = undefined
      this.customTime = false

      this.getStatisticsData()
    },
    getStaff () {
      Staff.get_staff().then(res => {
        if (res.data && res.data.code === 1) {
          this.currentStaff = res.data.data
          if (res.data.data.erp_role_id === 1) {
            this.isManager = true
            this.getSellers()
          }
        } else {
          this.$message.error(res.data.msg || '获取员工信息出错')
        }
      })
    },
    getMystaffs () {
      Staff.get_my_staffs().then(({ data }) => {
        if (data.data && data.data.length > 0) {
          this.isManager = true
          this.sellers = data.data
        }
      })
    },
    getSellers () {
      Customer.get_salesmen().then(res => {
        this.sellers = res.data.data
      })
    },
    getStatisticsData () {
      let _start = this.startTime ? this.startTime.format('YYYY-MM-DD') : ''
      let _end = this.endTime ? this.endTime.format('YYYY-MM-DD') : ''
      let _period =
        this.currentPeriodIndex !== undefined
          ? this.periods[this.currentPeriodIndex].value
          : ''
      let params = {
        staff_id: this.currentStaff.id,
        period: _period,
        start: _start,
        end: _end
      }
      Staff.get_staff_statistics(params).then(res => {
        if (res.data && res.data.code === 1) {
          let data = res.data.data
          this.customerNum = data.customer_num
          this.orderNum = data.order_num
          this.recordNum = data.record_num
          this.orderAmount = data.order_amount
          this.dataLoading = false
        } else {
          this.$message.error(res.data.msg || '获取统计数据失败')
        }
      })
    },
    setFilterParams () {
      if (this.customTime) {
        let _start = this.startTime ? this.startTime.format('YYYY-MM-DD') : ''
        let _end = this.endTime ? this.endTime.format('YYYY-MM-DD') : ''
        this.$store.dispatch('storeParams', {
          staff_id: this.currentStaff.id,
          end: _end,
          start: _start
        })
      } else {
        this.$store.dispatch('storeParams', {
          staff_id: this.currentStaff.id,
          period: this.periods[this.currentPeriodIndex].value
        })
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
#user-page {
  min-height: 100vh;
  background: #f5f6fa;

  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

    .header-back,
    .header-action {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      transition: background 0.2s;

      &:active {
        background: #f0f0f0;
      }
    }

    .header-title {
      font-size: 17px;
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .profile-card {
    display: flex;
    align-items: center;
    margin: 12px;
    padding: 20px 16px;
    background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: 600;
      color: #fff;
      flex-shrink: 0;
    }

    .profile-info {
      margin-left: 14px;

      .profile-name {
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        line-height: 1.3;
      }

      .profile-tel {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);
        margin-top: 4px;
      }
    }
  }

  .section-card {
    margin: 12px;
    padding: 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

    .section-label {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 12px;
    }

    .period-tabs {
      display: flex;
      gap: 8px;
      margin-bottom: 14px;

      .period-tab {
        flex: 1;
        text-align: center;
        padding: 8px 0;
        border-radius: 20px;
        font-size: 13px;
        color: #666;
        background: #f5f6fa;
        cursor: pointer;
        transition: all 0.25s;

        &:active {
          transform: scale(0.96);
        }

        &.active {
          background: #409eff;
          color: #fff;
          font-weight: 500;
        }
      }
    }

    .date-range {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      padding-top: 14px;
      border-top: 1px solid #f0f0f0;

      .date-field {
        flex: 1;
        min-width: 0;

        .date-label {
          font-size: 12px;
          color: #999;
          margin-bottom: 6px;
        }

        .full-width-picker {
          width: 100%;
        }
      }

      .date-separator {
        padding-bottom: 8px;
        color: #ccc;
        font-size: 14px;
        flex-shrink: 0;
      }

      .date-confirm-btn {
        flex-shrink: 0;
        padding: 5px 16px;
        border-radius: 20px;
        font-size: 13px;
        color: #409eff;
        background: #ecf5ff;
        cursor: pointer;
        transition: all 0.25s;
        white-space: nowrap;
        margin-bottom: 1px;

        &:active {
          transform: scale(0.96);
        }

        &.active {
          background: #409eff;
          color: #fff;
        }
      }
    }
  }

  .stats-grid {
    padding: 0 12px 12px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;

    .stat-card {
      display: flex;
      align-items: center;
      padding: 16px 12px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
      cursor: pointer;
      transition: all 0.2s;

      &:active {
        transform: scale(0.98);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
      }

      .stat-icon-wrap {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        color: #fff;
        flex-shrink: 0;

        &.customers-bg {
          background: linear-gradient(135deg, #409eff, #66b1ff);
        }
        &.records-bg {
          background: linear-gradient(135deg, #67c23a, #85ce61);
        }
        &.orders-bg {
          background: linear-gradient(135deg, #e6a23c, #ebb563);
        }
        &.amount-bg {
          background: linear-gradient(135deg, #f56c6c, #f78989);
        }
      }

      .stat-body {
        flex: 1;
        margin-left: 10px;
        min-width: 0;

        .stat-value {
          font-size: 20px;
          font-weight: 700;
          color: #1a1a1a;
          line-height: 1.2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .stat-label {
          font-size: 12px;
          color: #999;
          margin-top: 2px;
        }
      }

      .stat-arrow {
        font-size: 12px;
        color: #ccc;
        flex-shrink: 0;
        margin-left: 4px;
      }
    }
  }
}

.staff-modal {
  .staff-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    padding: 4px;

    .staff-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 4px;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;

      &:active {
        background: #f5f6fa;
      }

      &.active {
        background: #ecf5ff;

        .staff-avatar {
          background: #409eff;
          color: #fff;
        }

        .staff-name {
          color: #409eff;
        }
      }

      .staff-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
        color: #666;
        transition: all 0.2s;
      }

      .staff-name {
        font-size: 12px;
        color: #333;
        margin-top: 6px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
    }
  }
}
</style>
